import * as React from 'react';
import {Route, RouteComponentProps} from 'react-router-dom';
import {connect} from 'react-redux';
import {LineBreak} from '@openfin/desktop-ui';

import {Footer} from '../../components/Panel/Footer';
import {Header} from '../../components/Panel/Header';
import {Panel} from '../../components/Panel/Panel';
import {ROUTES} from '../../../components/Router/consts';
import {Sidebar, SidebarItemProps} from '../../components/Panel/Sidebar';
import * as AboutIcon from '../../../assets/About.svg';
import * as LaunchbarIcon from '../../../assets/LaunchbarSettings.svg';
import * as ProfileIcon from '../../../assets/Profile.svg';
import * as SettingsIcon from '../../../assets/Settings.svg';
import {settingsPanelRoutes} from '../../../components/Router/routes';
import {RootState} from '../../../store/State';

import * as Styles from './SettingsPanel.module.scss';

type SidebarItemWithRoute = SidebarItemProps & {route?: string};

const sidebarItems: SidebarItemWithRoute[] = [
    {label: 'launchbar', image: LaunchbarIcon, route: ROUTES.SETTINGS_PANEL_LAUNCHBAR},
    {label: 'profile', image: ProfileIcon, route: ROUTES.SETTINGS_PANEL_PROFILE},
    {label: 'about', image: AboutIcon, route: ROUTES.SETTINGS_PANEL_ABOUT}
];

interface Props extends RouteComponentProps {
    isAdmin: boolean;
}

const SettingsPanelComponent: React.FC<Props> = (props) => {
    const {history, match, isAdmin} = props;
    const [items, setItems] = React.useState(sidebarItems);
    const handleClose = () => {
        history.push(ROUTES.HOME);
    };

    React.useEffect(() => {
        // Set the default settings view to the first enabled sub-setting if we aren't already on one
        if (match.isExact) {
            const firstTab = sidebarItems.find(({route}) => !!route);
            if (firstTab) {
                history.push(firstTab.route!);
            }
        }

        setItems(sidebarItems.map((item: SidebarItemWithRoute) => ({
            ...item,
            onClick: item.route ? (() => history.push(item.route!)) : undefined,
            selected: () => {
                return !!item.route && (history.location.pathname === item.route);
            }
        })));
    }, []);

    const title = sidebarItems.find((x) => x.route === history.location.pathname) || {label: ''};

    return (
        <Panel>
            <Header title="Settings" onClose={handleClose} icon={SettingsIcon} />
            <LineBreak>{title.label}</LineBreak>
            <div className={Styles['panel-content']}>
                <div className={Styles['settings-sub-panel']}>
                    {settingsPanelRoutes.map((route, i) => <Route component={route.Component} path={route.path} exact={true} key={i} />)}
                </div>
                <Sidebar items={items} />
            </div>
            <Footer title="Permissions" options={[{name: isAdmin ? 'Admin' : 'User'}]} />
        </Panel>
    );
};

const mapStateToProps = (state: RootState) => ({
    isAdmin: state.authentication.account.isAdmin
});

export const SettingsPanel = connect(mapStateToProps)(SettingsPanelComponent);
